const taskTemplates = require('../../task-templates');

const tasksData = [		
	/* Case 1 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		image: 'htx-education-about-1',
		title: 'Opgave 1',
		taskId: 'education-input-htx',
		text: `HTX er en forkortelse – hvad står bogstaverne for?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `HTX er en gymnasial uddannelse med fokus på teknologi, naturvidenskab og praktiske projekter.`,
		answer: 'Højere Teknisk Eksamen',
		altAnswers: ['Højre Teknisk Eksamen'],
		subtype: 'string',
		unit: null,
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		image: 'htx-education-about-2',
		title: 'Opgave 2',
		taskId: 'education-mc-htx-duration',
		text: `Hvor mange år tager en HTX-uddannelse som udgangspunkt?`,
		hintText: `I kan finde svaret her: <br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `En gymnasieuddannelse er bygget op, så man både når at have grundforløb og fordybelse i fagene.`,
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: '1 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: '2 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: '3 år', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: '4 år'
			})
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'education-mc-cool-school-items',
		text: `Når man skal i skole på HTX, hvilket udstyr tror I, man har brug for for at være klar til en dag med fag og projekter?`,
		hintText: `Det handler om ting, man bruger hver dag i undervisningen.`,
		popupText: `Gymnasiet handler ikke kun om bøger – gruppearbejde, teknologi og fælles projekter fylder også meget.`,
		layout: 'htx-cool-school-items',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'laptop', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'books', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'group-work', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'phone'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'money',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'smartboard', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'chefs-hat',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		image: 'htx-education-about-3',
		title: 'Opgave 4',
		taskId: 'education-mc-htx-students',
		text: `Hvor mange elever tror I, der cirka starter på HTX hvert år i Danmark?`,
		hintText: `HTX findes mange steder i Danmark. Tænk over, hvor mange elever der starter hvert år – og at uddannelsen varer 3 år.`,
		popupText: `HTX er en landsdækkende gymnasial uddannelse med tusindvis af elever i hele Danmark.`,
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Ca. 2.500'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ca. 5.000',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Ca. 10.000', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Ca. 20.000'
			})
		],
	}),

	/* Case 2 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		image: 'htx-eduction-education-1',
		title: 'Opgave 1',
		taskId: 'education-mc-3-characteristics',
		text: `Hvilke tre ting tror I, ofte beskriver elever, der vælger HTX?`,
		hintText: `I kan finde svaret her: <br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `HTX tiltrækker elever, der interesserer sig for teknologi og naturvidenskab og kan lide at arbejde med både teori og praktiske projekter.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'De vil gerne vil lære om sprog, kultur, økonomi og samfund'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'De kan lide at arbejde praktisk med laboratorier, forsøg og projekter.', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'De kan lide undervisning, der primært er teoretisk'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'De kan lide undervisning, der er både teoretisk og praktisk', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'De er klar over, at uddannelse kræver forberedelse og lektier i fritiden', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		taskId: 'education-sort-basic',
		title: 'Opgave 2',
		text: `Grundforløb på %school% – hvad hører med?
			<br /><br />I er nye på HTX og skal finde ud af, hvad der sker i grundforløbet. Kan I sortere det, der hører med, fra det, der ikke gør?`,
		hintText: `I kan finde svaret her: <br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `Grundforløbet er den første tid på gymnasiet, hvor alle prøver fag og studieretninger, før man vælger sin endelige retning.`,
		layout: 'education-sort-basic',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'true', title: `Sandt om grundforløbet`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'false', title: `Falsk om grundforløbet`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Introduktion til fag og studieretninger`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `De første 3 måneder på HTX er grundforløb`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Alle på en skole har de samme fag på grundforløbet`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Introduktion til alle gymnasiets undervisere og vejledere`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Grundforløbet starter allerede efter de første 3 måneder`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Man vælger selv, hvilke fag man skal have på grundforløbet`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Under grundforløbet skal man besøge videregående uddannelser`, categoryIds: ['false']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'education-order-visit',
		title: 'Opgave 3',
		text: `I dag handler det om %school%. Hvad tror I, er de bedste ting at gøre, hvis [School name] virker spændende? Sæt dem i den rækkefølge, I synes giver mest mening.`,
		hintText: `Det er i hvert falde en god ide at besøge et åbent hus.`,
		popupText: `Mange elever finder først ud af, om HTX er noget for dem, når de har været til åbent hus.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Prøve kræfter med %school%s HTX spil`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Skrive sig op til åbent hus direkte i spillet, når det er færdigt`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Læse mere på uddannelsesguiden - www.ug.dk`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Tale med sin vejleder og lærere`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Tage mor og far med til åbent hus`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Beslutte sig i god tid og ansøge`, correctOrderNumbers: [6]
			})
		]
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'education-order-university-job',
		title: 'Opgave 1',
		text: `Hvad tror I er rækkefølgen for en gymnasieelev, der drømmer om et job med en universitetsuddannelse? Sæt trinnene i rigtig rækkefølge – fra start til slut.`,
		hintText: `Start med skolen og slut med jobbet.`,
		popupText: `Det kan tage mange år fra man starter på gymnasiet, til man står færdig som fx læge eller jurist – men gymnasiet er et godt sted at begynde.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Færdiggøre grundskolen`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Begynde på gymnasiet`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælge studieretning og fagpakke`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Gennemføre gymnasieeksamen`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Fuldføre videregående uddannelse`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Starte i job`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'education-sort-dreams',
		title: 'Opgave 2A',
		text: `Hvilke jobs og karrierer tror I, mange HTX-elever går og drømmer om?`,
		hintText: `ChatGPT kan hjælpe jer godt på vej.`,
		popupText: `Mange HTX-elever drømmer om job, hvor man arbejder med teknologi, naturvidenskab og praktiske løsninger.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'typical', title: `Typiske drømme`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notTypical', title: `Ikke typiske drømme`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Læge`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Ingeniør`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Dyrlæge`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Arkitekt`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Forsker`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Programmør`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Designer`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Frisør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 9, text: `Revisor`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 10, text: `Marketingchef`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 11, text: `Salgsdirektør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 12, text: `Psykolog`, categoryIds: ['notTypical']})
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		title: 'Opgave 2B',
		taskId: 'education-paper-doll-doctor',
		lockedById: 'education-sort-dreams',
		layout: 'education-doctor',
		avatarId: 'avatar-1',
		text: `Et af jobbene, vi nævnte, var læge. Hvilket udstyr tror I, man bruger som læge? Vælg de ting, der passer bedst – og klik OK, når I synes, I har ramt rigtigt.`,
		hintText: `Tænk på, hvad en læge bruger i hverdagen.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'syringe-b', title: 'Sprøjte med nål', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'lab-coat-white', title: 'Hvid kittel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'chart', title: 'Notatblok til journalføring', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'camera-b', title: 'Kamera'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'paint-brush', title: 'Malerpensel'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'safety-shoes', title: 'Sikkerhedssko'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'stethoscope', title: 'Stetoskop', isCorrect: true
			})
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 3',
		taskId: 'education-spot-errors-job-event',
		layout: 'education-job-event',
		text: `Mange gymnasieelever tager til jobmesser og karriereevents. På billedet ser I en elev til en jobmesse – men der er nogle ting, der ikke helt passer. Kan I finde dem? Klik OK, når I tror, I har alle.`,
		hintText: `Kig på ting, der virker forkerte i et professionelt møde.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tie'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'chair'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'paper'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'cup'})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 5,
		title: 'Opgave 4',
		taskId: 'education-input-limits',
		text: `Hvis man vælger HTX, sætter det så grænser for, hvad man kan blive i fremtiden?`,
		hintText: `Gå med jeres fornemmelse.`,
		popupText: `HTX er faktisk den ungdomsuddannelse i Danmark, der giver adgang til flest uddannelser bagefter.`,
		answer: 'Nej',
		subtype: 'string',
		unit: null
	}),
	/* Case 4 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-all-school-offer',
		text: `Er det rigtigt, at alle gymnasier tilbyder alle eksisterende studieretninger?`,
		hintText: `Tænk på forskelle mellem små og store gymnasier.`,
		popupText: `Hvert gymnasium vælger selv, hvilke studieretninger de udbyder – derfor er der forskelle rundt i landet.`,
		image: 'htx-education-fields-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Nej', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ja'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'education-facts',
		text: `Hvad tror I er rigtigt om studieretningerne?`,
		hintText: `I kan finde svaret her: <br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `Studieretningen er central, fordi den bestemmer niveauer i fagene og dermed, hvilke videregående uddannelser man senere kan søge ind på.`,
		image: 'htx-education-fields-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Du kan vælge studieretning hvert år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Valget af studieretning påvirker hvilke fag og niveauer du får', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Valg af studieretning kan have betydning for videregående uddannelser', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Alle studieretninger giver adgang til alle uddannelser'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3A',
		taskId: 'education-mc-fields-of-study',
		text: `At vælge studieretning er noget, mange ser frem til, når de starter på gymnasiet – og der er masser at vælge imellem. Find de 2 billeder, der passer til HTX-studieretninger.`,
		hintText: `Det kan googles på "HTX studieretninger"`,
		layout: 'htx-fields-of-study',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'science', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'society'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'languages'
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'art', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'finance',
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'media',
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'technology', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 4,
		taskId: 'education-sort-emojis',
		lockedById: 'education-mc-fields-of-study',
		subtype: 'images',
		title: 'Opgave 3B',
		text: `Gæt studieretningen!
			<br />Vi har samlet nogle emojis, der viser fagene og temaerne i en studieretning. Kan I finde ud af, hvilken det er? Tryk på det rigtige svar og se, om I har styr på studieretningerne!`,
		hintText: `Prøv at matche ikonerne med et fagområde.`,
		layout: 'htx-fields-emojis',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'science', title: `Naturvidenskab`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'technology', title: `Teknologi`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'programming', title: `Programmering`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'math', title: `Matematik`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'microscope', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'dna', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'tube', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'telescope', type: 'image', categoryIds: ['science']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'satellite', type: 'image', categoryIds: ['technology']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'robot', type: 'image', categoryIds: ['technology']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'laptop', type: 'image', categoryIds: ['programming']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'programming', type: 'image', categoryIds: ['programming']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'ruler', type: 'image', categoryIds: ['math']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'numbers', type: 'image', categoryIds: ['math']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 5,
		taskId: 'education-order-study-field',
		title: 'Opgave 4',
		text: `Vi leger, at I er elever, der skal vælge en studieretning. Hvad tror I, at man oplever undervejs? Sæt trinnene i den rækkefølge, de typisk sker.`,
		hintText: `Overvej, hvad der logisk sker først, når man starter.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Introforløb på gymnasiet`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Overvej interesser og fremtid`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælg og søg en studieretning`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Start på fagene`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Arbejd med fag og eksamen`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Gå til eksamen i de valgte fag`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 6,
		title: 'Opgave 5',
		taskId: 'education-when-choose-field',
		text: `Hvornår vælger man sin studieretning på HTX?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `Studieretning vælges først efter grundforløbet, fordi eleverne skal prøve fagene af, inden de træffer et endeligt valg.`,
		image: 'stx-fields-of-study',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Første skoledag'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Før man starter',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'I slutningen af grundforløbet', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Når man afslutter 1. g'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Det kan man selv bestemme'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Når man afslutter 2. g'
			}),
		],
	}),
	// Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1',
	// 	taskId: 'education-spot-errors-sfx-room',
	// 	layout: 'fields-sfx-classroom',
	// 	text: `Velkommen til et af gymnasiets store lokaler! Men nogle af eleverne passer vist ikke helt ind på et typisk STX-gymnasium. Find fejlene – og tryk OK, når I tror, I har dem alle.`,
	// 	hintText: `Nogle af personerne laver noget, man aldrig gør på STX.`,
	// 	errors: [
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'sawing'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'money'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tool'})
	// 	]
	// }),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 2,
	// 	taskId: 'education-order-science-day',
	// 	title: 'Opgave 2',
	// 	text: `Hvordan tror I, en helt dag kan se ud for en elev på naturvidenskabs-studieretningen, som også selv elsker astronomi? Sæt dagen i den rækkefølge, I synes passer bedst.`,
	// 	hintText: `Her er det en god ide at tale sammen i gruppen og gætte sig frem`,
	// 	popupText: `Dagen følger et naturligt flow, men kan selvfølgelig være forskelligt mellem elever.`,
	// 	layout: 'halfdouble-height',
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 1, text: `Vågne op og spise morgenmad`, correctOrderNumbers: [1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 2, text: `Tage bussen eller cykle til skolen`, correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 3, text: `Starte dagen med en naturvidenskabstime med forsøg`, correctOrderNumbers: [3]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 4, text: `Hygge med venner i frikvarteret`, correctOrderNumbers: [4]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 5, text: `Arbejde på et projekt i biologilokalet`, correctOrderNumbers: [5]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 6, text: `Lave lektier derhjemme`, correctOrderNumbers: [6]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 7, text: `Chille til en nice film om rummet`, correctOrderNumbers: [7]
	// 		})
	// 	]
	// }),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 7,
		title: 'Opgave 6',
		taskId: 'education-paper-doll-chemistry',
		layout: 'fields-chemistry',
		avatarId: 'avatar-3',
		text: `Kemi er et fag, mange synes er spændende. Hvad tror I, man arbejder med i laboratoriet?
			<br />Klik OK, når I synes, I har valgt de rigtige ting.`,
		hintText: `Tænk på ting, man bruger til forsøg – ikke hospitalet.`,
		popupText: `En bunsenbrænder og kitler hører til naturvidenskab på HTX, mens ting som stetoskop eller radioaktivt symbol ikke bruges i gymnasiet.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'bunsen', title: 'Bunsenbrænder', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'lab-coat-grey', title: 'Kittel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'tube', title: 'Reagensglas', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'dna', title: 'DNA streng', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'syringe', title: 'Sprøjte med nål'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'radioactive', title: 'Radioaktivt logo'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'stethoscope', title: 'Medicinsk stetoskop'
			}),
		]
	}),

	/* Case 5 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 1,
		taskId: 'education-sort-required',
		title: 'Opgave 1A',
		text: `På HTX vælger du selv nogle fag – men de fleste er obligatoriske. Hvilke af disse tror I bl.a., alle skal have?`,
		hintText: `I kan finde svaret her: <br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `De obligatoriske fag er valgt, så alle får en bred grundpakke.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'required', 
				title: `Obligatoriske fag`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'notRequired', 
				title: `Ikke obligatoriske fag`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Idehistorie`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Engelsk`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Matematik`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Fysik`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Biologi`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Kemi`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, text: `Tysk`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 9, text: `Filosofi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 10, text: `Oldtidskundskab`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 11, text: `Idræt`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 12, text: `Erhvervsøkonomi`, categoryIds: ['notRequired']
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 2,
		taskId: 'education-sort-levels',
		title: 'Opgave 1B',
		lockedById: 'education-sort-required',
		text: `På HTX er fagene på tre niveauer: A, B og C – og A er det højeste. Hvilket niveau har man som udgangspunkt de her fag på?`,
		hintText: `I kan finde svaret her: <br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `A-, B- og C-niveau er et system, der sikrer du kan blive dygtigere, hvert niveau tager et skoleår at gennemføre.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'a', 
				title: `A-niveau`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'b', 
				title: `B-niveau`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'c', 
				title: `C-niveau`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk`, categoryIds: ['a']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Teknikfag`, categoryIds: ['a']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Fysik`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Matematik`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Biologi`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Samfundsfag`, categoryIds: ['c']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 3,
		title: 'Opgave 2',
		taskId: 'education-rules',
		text: `Hvordan fungerer fagene på HTX?
			<br /><br />Kan I spotte, hvilke regler der gælder for A-niveaufag – og hvad man selv kan vælge? Vælg de rigtige svar!`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/teknisk-studentereksamen-htx`,
		popupText: `Reglen om mindst fire A-niveaufag betyder, at alle elever kommer igennem et højt fagligt niveau.`,
		image: 'classroom-students-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Som elev på HTX skal du have mindst fire fag på A-niveau'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Som elev på HTX skal du have mindst tre fag på A-niveau', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Man kan godt vælge at få endnu flere A-niveau fag hvis man selv ønsker det', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Man kan ikke vælge at få flere A-niveau fag hvis man selv ønsker det'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Man kan vælge de samme valgfag på alle HTX gymnasier i Danmark'
			}),
		],
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'htx-design-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};